import { usePermissions } from '../permissions/usePermissions';
import React, { useState, useEffect } from 'react';

import ArticleList from '../components/article/ArticleList';
import ArticleForm from '../components/article/ArticleForm';
import SingleArticle from '../components/article/SingleArticle';
import ArticleDeleteButton from '../components/article/ArticleDeleteButton';
import ArticleUpdateForm from '../components/article/ArticleupdateForm';
import BulkUploadArticles from '../components/article/BulkUploadArticles';
import ArticleZoningManager from '../components/article/ArticleZoningManager';

const ArticleManagementPage = () => {
  const { can, zoning } = usePermissions('articles');
  const [currentView, setCurrentView] = useState('list');
  const [selectedArticleId, setSelectedArticleId] = useState(null);




  const handleSelectArticle = (id) => {
    setSelectedArticleId(id.code_art);
    setCurrentView('view');
  };

  return (
    <div>
    
      {currentView === 'create' && can('create') && <ArticleForm />}
      {currentView === 'bulkUpload' && <BulkUploadArticles />}
      {currentView === 'zoning' && zoning && <ArticleZoningManager onChangeView={setCurrentView} />}
      
      {currentView === 'list' && <ArticleList onSelectArticle={handleSelectArticle} onChangeView={setCurrentView} />}
      {currentView === 'view' && selectedArticleId && (
        <SingleArticle articleId={selectedArticleId} onChangeView={setCurrentView} />
      )}
    </div>
  );
};

export default ArticleManagementPage;
